
export const baseUrl = "https://atci.lkm.eitacademy.accenture.com/ips-apis"
// export const baseUrl = "http://localhost:3001";
// export const imageBaseUrl = "http://localhost:3001/uploads/oracle-awards"
export const imageBaseUrl = "https://atci.lkm.eitacademy.accenture.com/eit-images"